import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchCatalog, deleteCatalog, editCatalog, clearCatalogsErrors,
  fetchItems, addCatalogItem, deleteCatalogItem } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import EditCatalog from '../components/catalogs/EditCatalog';
import Alert from '../components/home/Alert';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import _ from 'lodash';
import Toggle from 'material-ui/Toggle';
import Pagination from '../components/home/Pagination';
import Checkbox from 'material-ui/Checkbox';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  catalog: PropTypes.any,
  catalogs: PropTypes.any,
  catalogId: PropTypes.string.isRequired,
  error: PropTypes.any,
  query: PropTypes.object.isRequired,
  items: PropTypes.array,
  itemsMeta: PropTypes.object,
  router: PropTypes.object,
};

class CatalogEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertOpen: false,
      alertMessage: '',
      viewRedirect: false,
      edited: false,
      itemsList: [],
      catalogItemsMap: new Map(),
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
    const { catalogId, query, router } = this.props;
    query.showDisabled = false;
    if (!query.page) {
      query.page = 1;
      router.push({ pathname: location.pathname, query });
    } else {
      query.showDisabled = false;
      this.props.dispatch(fetchItems(query));
    }
    this.props.dispatch(fetchCatalog(catalogId));
  }
  componentWillReceiveProps(nextProps) {
    const nextState = this.state;
    const { catalog } = nextProps;
    const { catalogItemsMap } = this.state;
    const { query } = this.props;
    query.showDisabled = false;
    query.page = 1;
    switch (true) { // eslint-disable-line default-case
      case (catalog && catalog.assignedOnly === true):
        query.catalogId = catalog.id;
        this.props.dispatch(fetchItems(query));
        catalog.assignedOnly = null;
        this.setState({ catalog });
        break;

      case (catalog && catalog.assignedOnly === false):
        delete catalog.assignedOnly;
        delete query.catalogId;
        this.props.dispatch(fetchItems(query));
        this.setState({ catalog });
        break;
    }

    let itemsList = [];
    if (catalog) {
      catalogItemsMap.clear();
      _.each(catalog.items, item => {
        catalogItemsMap.set(item.id, item);
      });

      itemsList = _.map(nextProps.items, (item) => {
        const newItem = _.clone(item);
        if (catalogItemsMap.has(item.id)) {
          newItem.inCatalog = true;
        } else {
          newItem.inCatalog = false;
        }
        return newItem;
      });
    }
    nextState.itemsList = itemsList;
    switch (true) { // eslint-disable-line default-case
      case (nextProps.error):
        _.merge(nextState, {
          alertOpen: true,
          edited: false,
          alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
          error: true,
        });
        break;
      case (catalog && !nextProps.error && this.state.edited):
        _.merge(nextState, {
          alertOpen: true,
          alertMessage: 'Catalog edited succesfully!',
          error: false,
        });
        break;
    }
    this.setState(nextState);
  }
  onChangeNewCatalogItem(e) {
    const nextState = _.clone(this.state);
    if (!_.isNumber(e.target.value)) {
      return;
    }
    nextState.newCatalogItem[e.target.name] = e.target.value;
    this.setState(nextState);
  }
  handleItemToggle(pItem) {
    const { catalog } = this.props;
    const { catalogItemsMap } = this.state;
    const item = _.clone(pItem);
    delete item.inCatalog;
    if (catalogItemsMap.has(item.id)) {
      catalogItemsMap.delete(item.id);
      catalog.items = Array.from(catalogItemsMap.values());
      this.props.dispatch(deleteCatalogItem(catalog.id, item.id));
    } else {
      catalogItemsMap.set(item.id, item);
      catalog.items = Array.from(catalogItemsMap.values());
      this.props.dispatch(addCatalogItem({ catalogId: catalog.id, item: { itemId: item.id } }));
    }
  }
  handleAssignedOnly(e) {
    const { catalog } = this.props;
    catalog.assignedOnly = e.target.checked;
    this.setState({ catalog });
    browserHistory.push(`/catalogs/${this.props.catalog.id}`);
  }
  navigation(route) {
    this.props.dispatch(fetchItems(route));
  }

  navigateToView(catalog) {
    const nextState = this.state;
    nextState.viewRedirect = true;
    nextState.edited = true;
    this.setState(nextState);
    this.props.dispatch(editCatalog(catalog));
  }
  alertHandleClose() {
    this.setState({
      alertOpen: false,
      edited: false,
      alertMessage: '',
      viewRedirect: false,
    });
    this.props.dispatch(clearCatalogsErrors());
    if (!this.state.error) {
      if (this.state.viewRedirect === true) {
        browserHistory.push(`/catalogs/view/${this.props.catalog.id}`);
      } else {
        browserHistory.push('/catalogs?page=1');
      }
    }
  }
  deleteCatalog(catalogId) {
    const { catalogs } = this.props;
    catalogs.delete = true;
    this.setState({ catalogs });
    this.props.dispatch(deleteCatalog(catalogId));
    browserHistory.push('/catalogs?page=1');
  }
  saveEditCatalog(catalog) {
    this.setState({
      edited: true,
    });
    this.props.dispatch(editCatalog(catalog));
  }
  renderRowsTable() {
    return this.state.itemsList.map(item =>
      <TableRow key={item.id}>
        <TableRowColumn>{item.name}</TableRowColumn>
        <TableRowColumn>{item.productName}</TableRowColumn>
        <TableRowColumn>{item.sku}</TableRowColumn>
        <TableRowColumn>
          <Toggle
            labelPosition="right"
            onToggle={() => this.handleItemToggle(item)}
            defaultToggled={item.inCatalog}
          />
        </TableRowColumn>
      </TableRow>
    );
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    const tableStyles = {
      showCheckboxes: false,
      stripedRows: true,
      displaySelectAll: false,
      adjustForCheckbox: false,
      selectable: false,
      displayRowCheckbox: false,
    };
    return (
      <div className="catalogs component" style={authPage}>
        <h2>Edit Catalog</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="content">
          <EditCatalog
            catalog={this.props.catalog}
            onSave={data => this.saveEditCatalog(data)}
            onDelete={data => this.deleteCatalog(data)}
            onView={data => this.navigateToView(data)}
          />
        </div>

        <h2>Catalog Items</h2>
        <div className="content">
          <div>
            <Checkbox
              style={{ float: 'left', width: '40%' }}
              label="View Assigned Items Only"
              defaultChecked={this.state.assignedOnly}
              name="assignedOnly"
              onCheck={this.handleAssignedOnly}
            />
            <div className="action-buttons top">
              <Pagination
                paginationInfo={this.props.itemsMeta}
                pageCall={route => this.navigation(route)}
                pageName={`/catalogs/${_.get(this, 'props.catalog.id')}`}
              />
            </div>
          </div>
          <Table
            wrapperStyle={{ overflow: 'inherit' }}
            selectable={tableStyles.selectable}
            multiSelectable={tableStyles.multiSelectable}
          >
            <TableHeader
              displaySelectAll={tableStyles.showCheckboxes}
              adjustForCheckbox={tableStyles.showCheckboxes}
              enableSelectAll={tableStyles.enableSelectAll}
            >
              <TableRow
                selectable={tableStyles.selectable}
              >
                <TableHeaderColumn>Name</TableHeaderColumn>
                <TableHeaderColumn>Product</TableHeaderColumn>
                <TableHeaderColumn>SKU</TableHeaderColumn>
                <TableHeaderColumn>Assigned</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody
              stripedRows={tableStyles.stripedRows}
              displayRowCheckbox={tableStyles.displayRowCheckbox}
            >
              {this.renderRowsTable()}
            </TableBody>
          </Table>
        </div>
        <div className="action-buttons bottom">
          <Pagination
            paginationInfo={this.props.itemsMeta}
            pageCall={route => this.navigation(route)}
            pageName={`/catalogs/${_.get(this, 'props.catalog.id')}`}
          />
        </div>
      </div>
    );
  }
}

CatalogEditPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

CatalogEditPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    catalog: state.catalogs.catalog,
    catalogs: state.catalogs,
    catalogId: ownProps.params.id,
    error: state.catalogs.error,
    itemsMeta: state.items.meta,
    items: state.items.results,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(CatalogEditPage));



// WEBPACK FOOTER //
// ./src/containers/CatalogEditPage.js